import { render, staticRenderFns } from "./form-multi-dropdown.vue?vue&type=template&id=137adc90&scoped=true"
import script from "./form-multi-dropdown.vue?vue&type=script&lang=js"
export * from "./form-multi-dropdown.vue?vue&type=script&lang=js"
import style0 from "./form-multi-dropdown.vue?vue&type=style&index=0&id=137adc90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137adc90",
  null
  
)

export default component.exports